import { createStore, createEvent, createEffect, combine } from 'effector';
import { get } from 'lodash';

import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from './preloaders';

export const reset = createEvent('User messages reset');

export const getList = createEffect({
  name: 'getUserMessages',
  async handler(accountId: string) {
    const response = await request(api.spam.getUserMessages, {
      urlParams: {
        accountId,
      },
      data: {
        pagination: {
          page: 0,
          pageSize: 30,
          type: 'PAGE',
        },
      },
    });

    return response;
  },
});

const preloaders = createPreloadersStore([getList]);

const getRecipientName = (message: any) => {
  if (message?.recipient) {
    return message.recipient;
  }

  const claim = message?.claim;

  if (claim?.chattedWith?.nickname) {
    return claim.chattedWith.nickname;
  }

  if (claim?.tribe?.name) {
    return claim.tribe.name;
  }

  if (claim?.groupChat?.name) {
    return claim.groupChat.name;
  }

  return '-';
};

const list = createStore<any[]>([])
  .on(getList.done, (_, { result }) => {
    const data = get(result, ['data', 'body', 'result'], []);

    return data.map((item: any) => {
      return {
        ...item,
        recipient: getRecipientName(item),
      };
    });
  })
  .reset(reset);

const userMessages = combine({
  preloaders,
  list,
});

export default userMessages;
